import * as React from "react";
import PropTypes from 'prop-types';

const SvgLocationFill = props => {
  if (props.id !== "_svglocationfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><path d="M120 .091c-48.325 0-87.5 38.5-87.5 93.5s87.502 146.317 87.502 146.317 87.498-91.4 87.498-146.567S168.324.091 120 .091zm0 133.862c-26.441 0-47.953-21.512-47.953-47.953S93.559 38.047 120 38.047 167.953 59.559 167.953 86 146.441 133.953 120 133.953z" /></svg>;
};

SvgLocationFill.displayName = "_svglocationfill";
SvgLocationFill.propTypes = {
  id: PropTypes.string
};
SvgLocationFill.defaultProps = {
  id: ''
};
export default SvgLocationFill;